<template>
  <ul class="nav nav-mobile-menu">
  </ul>
</template>
<script>
  import DropDown from 'src/components/Dropdown.vue'

  export default {
    components: {
      DropDown
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Layout/Extra/MobileMenu.vue